var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevops(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 555.63 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-2);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69, .cls-70, .cls-71, .cls-72, .cls-73, .cls-74, .cls-75, .cls-76, .cls-77, .cls-78, .cls-79, .cls-80, .cls-81, .cls-82, .cls-83, .cls-84, .cls-85, .cls-86, .cls-87, .cls-88, .cls-89, .cls-90, .cls-91, .cls-92, .cls-93, .cls-94, .cls-95, .cls-96, .cls-97, .cls-98, .cls-99, .cls-100, .cls-101, .cls-102, .cls-103, .cls-104, .cls-105, .cls-106, .cls-107, .cls-108, .cls-109, .cls-110, .cls-111, .cls-112, .cls-113, .cls-114, .cls-115, .cls-116, .cls-117, .cls-118, .cls-119, .cls-120, .cls-121, .cls-122, .cls-123, .cls-124, .cls-125, .cls-126, .cls-127, .cls-128, .cls-129, .cls-130, .cls-131, .cls-132, .cls-133, .cls-134, .cls-135, .cls-136, .cls-137, .cls-138, .cls-139, .cls-140, .cls-141, .cls-142, .cls-143, .cls-144, .cls-145, .cls-146, .cls-147, .cls-148, .cls-149, .cls-150, .cls-151, .cls-152, .cls-153, .cls-154, .cls-155, .cls-156, .cls-157, .cls-158, .cls-159, .cls-160, .cls-161, .cls-162, .cls-163, .cls-164, .cls-165, .cls-166, .cls-167, .cls-168, .cls-169, .cls-170, .cls-171, .cls-172, .cls-173, .cls-174, .cls-175, .cls-176, .cls-177, .cls-178, .cls-179, .cls-180, .cls-181, .cls-182, .cls-183, .cls-184, .cls-185, .cls-186, .cls-187, .cls-188, .cls-189, .cls-190, .cls-191, .cls-192, .cls-193, .cls-194, .cls-195, .cls-196, .cls-197, .cls-198, .cls-199, .cls-200, .cls-201, .cls-202, .cls-203, .cls-204, .cls-205, .cls-206, .cls-207, .cls-208, .cls-209, .cls-210, .cls-211, .cls-212, .cls-213 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_225-2);\n      }\n\n      .cls-2, .cls-4, .cls-5, .cls-6, .cls-7, .cls-11, .cls-12, .cls-14, .cls-15, .cls-17, .cls-18, .cls-26, .cls-27, .cls-29, .cls-30, .cls-33, .cls-36, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-55, .cls-56, .cls-59, .cls-60, .cls-62, .cls-63, .cls-65, .cls-68, .cls-69, .cls-72, .cls-74, .cls-75, .cls-76, .cls-78, .cls-79, .cls-83, .cls-85, .cls-87, .cls-95, .cls-97, .cls-99, .cls-101, .cls-102, .cls-105, .cls-106, .cls-107, .cls-111, .cls-113, .cls-115, .cls-121, .cls-123, .cls-132, .cls-133, .cls-135, .cls-136, .cls-138, .cls-140, .cls-145, .cls-146, .cls-148, .cls-151, .cls-154, .cls-155, .cls-156, .cls-159, .cls-162, .cls-163, .cls-164, .cls-165, .cls-168, .cls-169, .cls-171, .cls-173, .cls-175, .cls-178, .cls-182, .cls-185, .cls-186, .cls-187, .cls-188, .cls-189, .cls-190, .cls-194, .cls-196, .cls-198, .cls-200, .cls-201, .cls-202, .cls-204, .cls-208, .cls-209, .cls-211 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2, .cls-26, .cls-47, .cls-50, .cls-88, .cls-105, .cls-112, .cls-132, .cls-135, .cls-152, .cls-161, .cls-173, .cls-182, .cls-185, .cls-202 {\n        mix-blend-mode: screen;\n      }\n\n      .cls-3 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_192-12);\n      }\n\n      .cls-4 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_192-16);\n      }\n\n      .cls-5, .cls-9, .cls-170 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_43);\n      }\n\n      .cls-7 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_127-4);\n      }\n\n      .cls-8 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-42);\n      }\n\n      .cls-9, .cls-18, .cls-33, .cls-49, .cls-200 {\n        mix-blend-mode: soft-light;\n      }\n\n      .cls-10 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-55);\n      }\n\n      .cls-11 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_50-7);\n      }\n\n      .cls-12 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13-3);\n      }\n\n      .cls-13 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_50);\n      }\n\n      .cls-14 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_135-2);\n      }\n\n      .cls-15 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_244-2);\n      }\n\n      .cls-16 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-53);\n      }\n\n      .cls-17 {\n        fill: #791b36;\n        opacity: .45;\n      }\n\n      .cls-17, .cls-40, .cls-44, .cls-53, .cls-56, .cls-134, .cls-151, .cls-156, .cls-188, .cls-189 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-18 {\n        opacity: .8;\n      }\n\n      .cls-18, .cls-33 {\n        fill: #fbf9fa;\n      }\n\n      .cls-19 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-34);\n      }\n\n      .cls-20 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-17);\n      }\n\n      .cls-21 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-20);\n      }\n\n      .cls-22 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-50);\n      }\n\n      .cls-23 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13-5);\n      }\n\n      .cls-24 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_206-2);\n      }\n\n      .cls-25 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-60);\n      }\n\n      .cls-26 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_80);\n      }\n\n      .cls-26, .cls-33, .cls-40, .cls-44, .cls-47, .cls-53, .cls-56, .cls-156 {\n        opacity: .5;\n      }\n\n      .cls-27 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_57-2);\n      }\n\n      .cls-28 {\n        fill: #8e003e;\n      }\n\n      .cls-29 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_64);\n      }\n\n      .cls-30 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_192-5);\n      }\n\n      .cls-31 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-32);\n      }\n\n      .cls-32 {\n        fill: #2c0045;\n      }\n\n      .cls-34 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-59);\n      }\n\n      .cls-35 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-33);\n      }\n\n      .cls-36 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_135-3);\n      }\n\n      .cls-37 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-58);\n      }\n\n      .cls-38 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_192);\n      }\n\n      .cls-39 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_152);\n      }\n\n      .cls-40, .cls-44, .cls-188 {\n        fill: #601734;\n      }\n\n      .cls-41 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_135-4);\n      }\n\n      .cls-42 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_152-3);\n      }\n\n      .cls-43 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_50-8);\n      }\n\n      .cls-45 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-25);\n      }\n\n      .cls-46 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-24);\n      }\n\n      .cls-47 {\n        fill: #5656b1;\n      }\n\n      .cls-48 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_204);\n      }\n\n      .cls-49 {\n        fill: #fbd99a;\n      }\n\n      .cls-50 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_65);\n      }\n\n      .cls-50, .cls-152, .cls-182, .cls-188 {\n        opacity: .2;\n      }\n\n      .cls-51 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_206-5);\n      }\n\n      .cls-52 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_57-3);\n      }\n\n      .cls-53 {\n        fill: #8e4072;\n      }\n\n      .cls-54 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_36-3);\n      }\n\n      .cls-55 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_50-11);\n      }\n\n      .cls-56 {\n        fill: #401734;\n      }\n\n      .cls-57 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-36);\n      }\n\n      .cls-58 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_244);\n      }\n\n      .cls-59 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_50-16);\n      }\n\n      .cls-60 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_50-5);\n      }\n\n      .cls-61 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_50-2);\n      }\n\n      .cls-214 {\n        isolation: isolate;\n      }\n\n      .cls-62 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_127-2);\n      }\n\n      .cls-63 {\n        fill: #028bff;\n      }\n\n      .cls-64 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_18);\n      }\n\n      .cls-65 {\n        fill: #dedde7;\n      }\n\n      .cls-66 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_110);\n      }\n\n      .cls-67 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_204-4);\n      }\n\n      .cls-68 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_152-2);\n      }\n\n      .cls-69 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_206-9);\n      }\n\n      .cls-70 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-43);\n      }\n\n      .cls-71 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-11);\n      }\n\n      .cls-72 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_206-7);\n      }\n\n      .cls-73 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_105);\n      }\n\n      .cls-74 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_50-6);\n      }\n\n      .cls-75 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_127-3);\n      }\n\n      .cls-76 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_192-11);\n      }\n\n      .cls-77 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-16);\n      }\n\n      .cls-78 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_206-8);\n      }\n\n      .cls-79 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_99);\n      }\n\n      .cls-80 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-52);\n      }\n\n      .cls-81 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_38);\n      }\n\n      .cls-82 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-38);\n      }\n\n      .cls-83 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_135);\n      }\n\n      .cls-84 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-13);\n      }\n\n      .cls-85 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_50-14);\n      }\n\n      .cls-86 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-7);\n      }\n\n      .cls-87 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_96);\n      }\n\n      .cls-88 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_296-2);\n      }\n\n      .cls-89 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-21);\n      }\n\n      .cls-90 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-10);\n      }\n\n      .cls-91 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_57);\n      }\n\n      .cls-92 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-31);\n      }\n\n      .cls-93 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_192-13);\n      }\n\n      .cls-94 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_15);\n      }\n\n      .cls-95 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_50-12);\n      }\n\n      .cls-96 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_50-13);\n      }\n\n      .cls-97 {\n        fill: #a695cf;\n      }\n\n      .cls-98 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-57);\n      }\n\n      .cls-99 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_206-6);\n      }\n\n      .cls-100 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-6);\n      }\n\n      .cls-101 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_57-4);\n      }\n\n      .cls-102 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_127);\n      }\n\n      .cls-103 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280);\n      }\n\n      .cls-104 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_38-3);\n      }\n\n      .cls-105 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_329);\n      }\n\n      .cls-106 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_178);\n      }\n\n      .cls-107 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_192-2);\n      }\n\n      .cls-108, .cls-121 {\n        fill: #8b0c42;\n      }\n\n      .cls-109 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-5);\n      }\n\n      .cls-110 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-45);\n      }\n\n      .cls-111 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_192-6);\n      }\n\n      .cls-112 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_338);\n      }\n\n      .cls-113 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_43-2);\n      }\n\n      .cls-114 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_36-2);\n      }\n\n      .cls-115, .cls-156 {\n        fill: #ac2a41;\n      }\n\n      .cls-116 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-19);\n      }\n\n      .cls-117 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-8);\n      }\n\n      .cls-118 {\n        fill: #3492ff;\n      }\n\n      .cls-119 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_143);\n      }\n\n      .cls-120 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-4);\n      }\n\n      .cls-122 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-28);\n      }\n\n      .cls-123 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_7);\n      }\n\n      .cls-124 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-23);\n      }\n\n      .cls-125 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-15);\n      }\n\n      .cls-126 {\n        fill: #d1bfe8;\n      }\n\n      .cls-127 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_59-2);\n      }\n\n      .cls-128 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_20);\n      }\n\n      .cls-129 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-35);\n      }\n\n      .cls-130 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-48);\n      }\n\n      .cls-131 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-40);\n      }\n\n      .cls-132 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_296);\n      }\n\n      .cls-133 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_192-3);\n      }\n\n      .cls-134, .cls-151, .cls-189 {\n        opacity: .3;\n      }\n\n      .cls-134, .cls-189 {\n        fill: #540041;\n      }\n\n      .cls-135 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_343);\n      }\n\n      .cls-136 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13-2);\n      }\n\n      .cls-137 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-22);\n      }\n\n      .cls-138 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_102);\n      }\n\n      .cls-139 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-37);\n      }\n\n      .cls-140 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_50-10);\n      }\n\n      .cls-141 {\n        fill: #5e3075;\n      }\n\n      .cls-142 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-56);\n      }\n\n      .cls-143 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-12);\n      }\n\n      .cls-144 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-51);\n      }\n\n      .cls-145 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_50-9);\n      }\n\n      .cls-146 {\n        fill: #b870a1;\n      }\n\n      .cls-147 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_204-3);\n      }\n\n      .cls-148 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_192-9);\n      }\n\n      .cls-149 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-27);\n      }\n\n      .cls-150 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_86);\n        opacity: .58;\n      }\n\n      .cls-151 {\n        fill: #953345;\n      }\n\n      .cls-152 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_65-3);\n      }\n\n      .cls-153 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-26);\n      }\n\n      .cls-154 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_10-3);\n      }\n\n      .cls-155 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13-7);\n      }\n\n      .cls-157 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13-6);\n      }\n\n      .cls-158 {\n        fill: #fffb00;\n      }\n\n      .cls-159 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_10-2);\n      }\n\n      .cls-160 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-49);\n      }\n\n      .cls-161 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_108);\n      }\n\n      .cls-162 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_3);\n      }\n\n      .cls-163 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_192-4);\n      }\n\n      .cls-164 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_50-4);\n      }\n\n      .cls-165 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_3-3);\n      }\n\n      .cls-166 {\n        fill: #ff4f4a;\n      }\n\n      .cls-167 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_192-14);\n      }\n\n      .cls-168 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_112);\n      }\n\n      .cls-169 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_192-10);\n      }\n\n      .cls-171 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_204-2);\n      }\n\n      .cls-172 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_50-15);\n      }\n\n      .cls-173 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_225);\n      }\n\n      .cls-174 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-41);\n      }\n\n      .cls-175 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_115);\n      }\n\n      .cls-176 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-47);\n      }\n\n      .cls-177 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_36);\n      }\n\n      .cls-178 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_77);\n      }\n\n      .cls-179 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_192-15);\n      }\n\n      .cls-180 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-46);\n      }\n\n      .cls-181 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-39);\n      }\n\n      .cls-182 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_65-2);\n      }\n\n      .cls-183 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-14);\n      }\n\n      .cls-184 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-18);\n      }\n\n      .cls-185 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_129);\n      }\n\n      .cls-186 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_192-7);\n      }\n\n      .cls-187 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_3-2);\n      }\n\n      .cls-190 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_150);\n      }\n\n      .cls-191 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_53);\n      }\n\n      .cls-192 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-54);\n      }\n\n      .cls-193 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_206);\n      }\n\n      .cls-194 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_178-2);\n      }\n\n      .cls-195 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_38-2);\n      }\n\n      .cls-196 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_192-8);\n      }\n\n      .cls-197 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_59);\n      }\n\n      .cls-198 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_115-2);\n      }\n\n      .cls-199 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-44);\n      }\n\n      .cls-200 {\n        fill: #d1d8b3;\n      }\n\n      .cls-201 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_206-3);\n      }\n\n      .cls-202 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_299);\n      }\n\n      .cls-203 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_32);\n      }\n\n      .cls-204 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13-4);\n      }\n\n      .cls-205 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_50-3);\n      }\n\n      .cls-206 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-3);\n      }\n\n      .cls-207 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-30);\n      }\n\n      .cls-208 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_10);\n      }\n\n      .cls-209 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_206-4);\n      }\n\n      .cls-210 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13);\n      }\n\n      .cls-211 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_113);\n      }\n\n      .cls-212 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-9);\n      }\n\n      .cls-213 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_280-29);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 13",
    cx: 448.05,
    cy: 297.79,
    fx: 448.05,
    fy: 297.79,
    r: 32.41,
    gradientTransform: "translate(296.1 -320.71) rotate(34.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebd7e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#bdafd2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_38",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 38",
    x1: 448.05,
    y1: 321.64,
    x2: 448.05,
    y2: 273.94,
    gradientTransform: "translate(296.1 -320.71) rotate(34.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#ede9f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3e6ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_36",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 36",
    x1: 448.05,
    y1: 319.72,
    x2: 448.05,
    y2: 275.86,
    gradientTransform: "translate(296.1 -320.71) rotate(34.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#d4cbe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3e6ee"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 192",
    cx: 448.05,
    cy: 296.42,
    fx: 448.05,
    fy: 296.42,
    r: 15.57,
    gradientTransform: "translate(296.1 -320.71) rotate(34.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "aqua"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#26a9ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 50",
    x1: 253.8,
    y1: 2.36,
    x2: 294.71,
    y2: 2.36,
    gradientTransform: "translate(10.4 -13.96) rotate(9.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#603082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#2a0e51"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 206",
    cx: 274.69,
    cy: 15.01,
    fx: 274.69,
    fy: 15.01,
    r: 20.44,
    gradientTransform: "translate(10.4 -13.96) rotate(9.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d47d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#713592"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 206",
    cx: 274.25,
    cy: 2.36,
    fx: 274.25,
    fy: 2.36,
    r: 14.02,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 192",
    cx: 265.67,
    cy: 2.81,
    fx: 265.67,
    fy: 2.81,
    r: 6.26,
    gradientTransform: "translate(10.4 -13.96) rotate(9.35)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192-3",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 192",
    cx: -378.51,
    cy: 2.54,
    fx: -378.51,
    fy: 2.54,
    r: 6.26,
    gradientTransform: "translate(-84.05 -29.24) rotate(-170.65) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192-4",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 192",
    cx: 274.25,
    cy: 2.81,
    fx: 274.25,
    fy: 2.81,
    r: 6.59,
    gradientTransform: "translate(10.4 -13.96) rotate(9.35)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_143",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 143",
    cx: 258.13,
    cy: 214.43,
    fx: 258.13,
    fy: 214.43,
    r: 142.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1f84ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 50",
    x1: 360.93,
    y1: 256.41,
    x2: 351.96,
    y2: 202.05,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 115",
    x1: 392.41,
    y1: 266.6,
    x2: 537.47,
    y2: 266.6,
    gradientTransform: "translate(38.92 -34.08) rotate(6.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6e27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e03347"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_102",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 102",
    x1: 408.86,
    y1: 267.97,
    x2: 539.61,
    y2: 267.97,
    gradientTransform: "translate(38.92 -34.08) rotate(6.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c73e27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a4152c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_77",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 77",
    x1: 423.94,
    y1: 255.7,
    x2: 495.86,
    y2: 255.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebd7e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9c87bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7a8ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_99",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 99",
    x1: 423.94,
    y1: 249.35,
    x2: 495.85,
    y2: 249.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f36bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#2a0e51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_53",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 53",
    x1: 439.88,
    y1: 239.38,
    x2: 461.03,
    y2: 238.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a0e51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f174c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_43",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 43",
    x1: 440.09,
    y1: 238,
    x2: 462.8,
    y2: 238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f174c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#2a0e51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_96",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 96",
    x1: 443.69,
    y1: 238.04,
    x2: 459.82,
    y2: 237.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#688eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4c346c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_43-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 43",
    x1: 442.84,
    y1: 237.68,
    x2: 455.94,
    y2: 237.68,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_80",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 80",
    x1: 473.25,
    y1: 270.5,
    x2: 473.25,
    y2: 257.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_64",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 64",
    x1: 423.98,
    y1: 252.7,
    x2: 495.85,
    y2: 252.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f6bf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#000024"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_296",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 296",
    cx: 577.18,
    cy: 134.36,
    fx: 577.18,
    fy: 134.36,
    r: 5.28,
    gradientTransform: "translate(76.37 127.26) rotate(9.57) scale(.69 .35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb7c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#b05700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#713800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#401f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1d0e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50-3",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 50",
    x1: 106.08,
    y1: 316.25,
    x2: 334.28,
    y2: 316.25,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_127",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 127",
    x1: 186.54,
    y1: 256.12,
    x2: 186.54,
    y2: 135.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a0e45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#561f7d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_150",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 150",
    x1: 187.21,
    y1: 242.69,
    x2: 187.21,
    y2: 141.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4bffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2fc5ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 13",
    cx: 217.27,
    cy: -1779.08,
    fx: 217.27,
    fy: -1779.08,
    r: 59.04,
    gradientTransform: "translate(0 2612.74) scale(1 1.33)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50-4",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 50",
    x1: 184.94,
    y1: 276.89,
    x2: 184.94,
    y2: 256.12,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_57",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 57",
    cx: 184.24,
    cy: 278.88,
    fx: 184.24,
    fy: 278.88,
    r: 22.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3819d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#785ca6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13-3",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 13",
    cx: 184.24,
    cy: 275.83,
    fx: 184.24,
    fy: 275.83,
    r: 22.49,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_32",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 32",
    x1: 172.66,
    y1: 225.28,
    x2: 172.66,
    y2: 169.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_15",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 15",
    x1: 125.25,
    y1: 202.23,
    x2: 225.94,
    y2: 202.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6e27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_20",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 20",
    x1: 200.42,
    y1: 225.28,
    x2: 200.42,
    y2: 169.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcff27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_18",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 18",
    x1: 147.44,
    y1: 202.23,
    x2: 247.83,
    y2: 202.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd328"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_135",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 135",
    x1: 282.19,
    y1: 154.9,
    x2: 308.7,
    y2: 154.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd328"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 115",
    x1: 306.87,
    y1: 173.35,
    x2: 282.56,
    y2: 176.51,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_135-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 135",
    x1: 285.64,
    y1: 209.76,
    x2: 313.08,
    y2: 209.76,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_135"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_244",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 244",
    x1: 32,
    y1: 183.3,
    x2: 32,
    y2: 114.18,
    gradientTransform: "translate(31.9 37.18) scale(1 1.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6e27"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_178",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 178",
    cx: 31.76,
    cy: 140.08,
    fx: 31.76,
    fy: 140.08,
    r: 50.03,
    gradientTransform: "translate(-17.42 57.32) rotate(-19.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faf5f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#d4cbe2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_127-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 127",
    x1: 123.46,
    y1: 150.14,
    x2: 123.46,
    y2: 125.48,
    gradientTransform: "translate(11.77 3.3) rotate(23.95)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_127-3",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 127",
    x1: 197.71,
    y1: 81.85,
    x2: 197.71,
    y2: 63.81,
    gradientTransform: "translate(91.53 -20.9) rotate(75.23)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_127-4",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 127",
    x1: 32.29,
    y1: 155.84,
    x2: 32.29,
    y2: 149.24,
    gradientTransform: "translate(-17.42 57.32) rotate(-19.61)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_127"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_178-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 178",
    cx: 32.29,
    cy: 152.54,
    fx: 32.29,
    fy: 152.54,
    r: 1.6,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_178"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_7",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 7",
    x1: 41.07,
    y1: 292.37,
    x2: 330.93,
    y2: 292.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb934"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_299",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 299",
    cx: 365.23,
    cy: 286.14,
    fx: 365.23,
    fy: 286.14,
    r: 9.01,
    gradientTransform: "translate(133.46) scale(.38 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffef00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbec00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#b0a500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#716a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#403c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1d1b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13-4",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 13",
    cx: 230.39,
    cy: -1735.51,
    fx: 230.39,
    fy: -1735.51,
    r: 81.47,
    gradientTransform: "translate(0 2612.74) scale(1 1.33)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_135-3",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 135",
    x1: 106.96,
    y1: 292.62,
    x2: 330.93,
    y2: 292.62,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_135"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_225",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 225",
    x1: 179.75,
    y1: 298.4,
    x2: 178.97,
    y2: 283.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bd9f65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_10",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 10",
    x1: 41.07,
    y1: 300.17,
    x2: 330.93,
    y2: 300.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c93347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7527"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_296-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 296",
    cx: 271.94,
    cy: 251.51,
    fx: 271.94,
    fy: 251.51,
    r: 9.01,
    gradientTransform: "translate(257.49 -118.63) rotate(45)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_296"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_338",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 338",
    cx: 240.51,
    cy: 337.65,
    fx: 240.51,
    fy: 337.65,
    r: 9.01,
    gradientTransform: "translate(620.94 -339.96) rotate(90) scale(2.83 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0097ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0095fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#0068b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#004371"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#002640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00111d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#000407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_343",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 343",
    cx: 173.13,
    cy: 335.12,
    fx: 173.13,
    fy: 335.12,
    r: 5.65,
    gradientTransform: "translate(-521.5 -51.28) rotate(3.88) scale(3.79 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2a13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb2912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#b01d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#711208"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#400a04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1d0402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_86",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 86",
    x1: 410.7,
    y1: 336.24,
    x2: 410.7,
    y2: 337.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f0f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#cec4de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50-5",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 50",
    x1: 77.1,
    y1: 332.65,
    x2: 315.18,
    y2: 332.65,
    gradientTransform: "translate(26.16 -8.72) rotate(4.24)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_204",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 204",
    cx: 132.38,
    cy: 311.84,
    fx: 132.38,
    fy: 311.84,
    r: 108.23,
    gradientTransform: "translate(26.16 -8.72) rotate(4.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d47d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#713592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50-6",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 50",
    x1: 86.83,
    y1: 318.11,
    x2: 308.39,
    y2: 318.11,
    gradientTransform: "translate(26.16 -8.72) rotate(4.24)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206-3",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 206",
    cx: 197.61,
    cy: 315.5,
    fx: 197.61,
    fy: 315.5,
    r: 78.58,
    gradientTransform: "translate(26.16 -8.72) rotate(4.24)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 318.9,
    x2: 297.01,
    y2: 319.14,
    gradientTransform: "translate(26.16 -8.72) rotate(4.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#ff4c06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ff0e59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ff12c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 315,
    x2: 297.01,
    y2: 315.24,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-3",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 312.4,
    x2: 297.02,
    y2: 312.64,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-4",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 309.34,
    x2: 297.02,
    y2: 309.57,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-5",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 307.33,
    x2: 297.02,
    y2: 307.56,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-6",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 313.37,
    x2: 297.02,
    y2: 313.61,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-7",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 308.37,
    x2: 297.02,
    y2: 308.61,
    gradientTransform: "translate(156.29 -25.2) rotate(26.86)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-8",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 319.97,
    x2: 297.01,
    y2: 320.21,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-9",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 306.98,
    x2: 297.02,
    y2: 307.22,
    gradientTransform: "translate(182.49 -28.26) rotate(31.17)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-10",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 316.52,
    x2: 297.01,
    y2: 316.76,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-11",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 310.8,
    x2: 297.02,
    y2: 311.04,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-12",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 314.09,
    x2: 297.02,
    y2: 314.33,
    gradientTransform: "translate(355.49 -92.85) rotate(51.48)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-13",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 308.41,
    x2: 297.02,
    y2: 308.65,
    gradientTransform: "translate(348.96 -89.88) rotate(51.5)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-14",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 321.78,
    x2: 297.01,
    y2: 322.01,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-15",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 310.95,
    x2: 297.02,
    y2: 311.19,
    gradientTransform: "translate(311.68 -90.15) rotate(46.32)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-16",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 317.45,
    x2: 297.01,
    y2: 317.69,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-17",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 307.02,
    x2: 297.02,
    y2: 307.25,
    gradientTransform: "translate(308.68 -88.59) rotate(46.43)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-18",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 314.06,
    x2: 297.01,
    y2: 314.3,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-19",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 308.4,
    x2: 297.02,
    y2: 308.64,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-20",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 321.52,
    x2: 297,
    y2: 321.75,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-21",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.77,
    y1: 307.01,
    x2: 297.02,
    y2: 307.25,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-22",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 317.36,
    x2: 297.01,
    y2: 317.6,
    gradientTransform: "translate(170.64 -73.05) rotate(26.45)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-23",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 311,
    x2: 297.02,
    y2: 311.24,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-24",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 313.94,
    x2: 297.01,
    y2: 314.18,
    gradientTransform: "translate(140.24 -62.52) rotate(22.31)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-25",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 308.4,
    x2: 297.02,
    y2: 308.64,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-26",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 321.37,
    x2: 297,
    y2: 321.61,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-27",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 310.91,
    x2: 297.02,
    y2: 311.15,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-28",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.77,
    y1: 307.34,
    x2: 297.02,
    y2: 307.57,
    gradientTransform: "translate(97.8 -46.36) rotate(16.16)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-29",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 317.25,
    x2: 297.01,
    y2: 317.48,
    gradientTransform: "translate(97.09 -45.45) rotate(15.72)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-30",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.77,
    y1: 308.4,
    x2: 297.02,
    y2: 308.63,
    gradientTransform: "translate(41.55 -18.08) rotate(6.92)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-31",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 321.22,
    x2: 297,
    y2: 321.46,
    gradientTransform: "translate(42.25 -18.16) rotate(6.93)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-32",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.77,
    y1: 313.87,
    x2: 297.01,
    y2: 314.1,
    gradientTransform: "translate(42.09 -18.26) rotate(6.97)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-33",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 308.01,
    x2: 297.02,
    y2: 308.24,
    gradientTransform: "translate(213.34 -27.78) rotate(36.11)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-34",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 320.34,
    x2: 297.01,
    y2: 320.58,
    gradientTransform: "translate(216.49 -16.75) rotate(36.11)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-35",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 313.48,
    x2: 297.02,
    y2: 313.72,
    gradientTransform: "translate(214.78 -22.88) rotate(36.11)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-36",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 310.81,
    x2: 297.02,
    y2: 311.05,
    gradientTransform: "translate(245.9 -24.54) rotate(41.12)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-37",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 307.34,
    x2: 297.02,
    y2: 307.58,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-38",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 316.67,
    x2: 297.01,
    y2: 316.9,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-39",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 308.43,
    x2: 297.03,
    y2: 308.67,
    gradientTransform: "translate(260.94 -28.3) rotate(43.42)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-40",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 320.53,
    x2: 297.01,
    y2: 320.77,
    gradientTransform: "translate(297.34 -5.48) rotate(48.96)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-41",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 313.57,
    x2: 297.02,
    y2: 313.81,
    gradientTransform: "translate(262.61 -23.59) rotate(43.42)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-42",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 310.84,
    x2: 297.02,
    y2: 311.07,
    gradientTransform: "translate(303.72 -18.24) rotate(50.15)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-43",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 316.92,
    x2: 297.01,
    y2: 317.16,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-44",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 313.64,
    x2: 297.02,
    y2: 313.88,
    gradientTransform: "translate(351.54 -2.78) rotate(57.67)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-45",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.74,
    y1: 318.74,
    x2: 297.02,
    y2: 318.98,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-46",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 308.38,
    x2: 297.03,
    y2: 308.62,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-47",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.77,
    y1: 307.4,
    x2: 297.02,
    y2: 307.64,
    gradientTransform: "translate(382.47 .7) rotate(63.03)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-48",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 316.83,
    x2: 297.02,
    y2: 317.06,
    gradientTransform: "translate(398.58 16.48) rotate(65.03)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-49",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 310.86,
    x2: 297.02,
    y2: 311.09,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-50",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 313.72,
    x2: 297.02,
    y2: 313.96,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-51",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 308.34,
    x2: 297.03,
    y2: 308.58,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-52",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.75,
    y1: 310.88,
    x2: 297.03,
    y2: 311.11,
    gradientTransform: "translate(479.25 56.3) rotate(79.66)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-53",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 307.41,
    x2: 297.03,
    y2: 307.64,
    gradientTransform: "translate(476.61 52.9) rotate(79.66)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-54",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.74,
    y1: 317.02,
    x2: 297.02,
    y2: 317.26,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-55",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.79,
    y1: 308.33,
    x2: 297,
    y2: 308.57,
    gradientTransform: "translate(527.87 98.33) rotate(90)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-56",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.76,
    y1: 313.8,
    x2: 297.01,
    y2: 314.03,
    gradientTransform: "translate(532.93 103.78) rotate(90)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-57",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.77,
    y1: 307.41,
    x2: 297.02,
    y2: 307.65,
    gradientTransform: "translate(548.25 108.95) rotate(93.48)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-58",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.77,
    y1: 317.06,
    x2: 297,
    y2: 317.3,
    gradientTransform: "translate(557.14 117.62) rotate(93.31)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-59",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 110.78,
    y1: 310.89,
    x2: 297.01,
    y2: 311.13,
    gradientTransform: "translate(551.35 111.92) rotate(93.39)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280-60",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 280",
    x1: 89.4,
    y1: 329.23,
    x2: 304.97,
    y2: 329.23,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_280"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50-7",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 50",
    x1: 258.67,
    y1: 628.69,
    x2: 258.67,
    y2: 545.96,
    gradientTransform: "translate(-149.54 -56.01) rotate(-29.6)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206-4",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 206",
    cx: 378.13,
    cy: 546.23,
    fx: 378.13,
    fy: 546.23,
    r: 2.63,
    gradientTransform: "translate(-186.59 -34.26) rotate(-29.59) scale(.8 1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206-5",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 206",
    cx: 381.35,
    cy: 587.59,
    fx: 381.35,
    fy: 587.59,
    r: 28.68,
    gradientTransform: "translate(-186.59 -34.26) rotate(-29.59) scale(.8 1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206-6",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 206",
    cx: -757.52,
    cy: 2.27,
    fx: -757.52,
    fy: 2.27,
    r: 29.65,
    gradientTransform: "translate(-185.24 -63.93) rotate(-150.24) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206-7",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 206",
    cx: -884.1,
    cy: -39,
    fx: -884.1,
    fy: -39,
    r: 2.63,
    gradientTransform: "translate(-147.63 -41.96) rotate(-150.24) scale(.8 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50-8",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 50",
    x1: -881.23,
    y1: 43.71,
    x2: -881.23,
    y2: -38.1,
    gradientTransform: "translate(-147.63 -41.96) rotate(-150.24) scale(.8 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50-9",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 50",
    x1: 319.24,
    y1: 487.09,
    x2: 419.92,
    y2: 494.56,
    gradientTransform: "translate(-44.83 -28.9) rotate(-12.84)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206-8",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 206",
    cx: 370.3,
    cy: 476.12,
    fx: 370.3,
    fy: 476.12,
    r: 36.6,
    gradientTransform: "translate(-44.83 -28.9) rotate(-12.84)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50-10",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 50",
    x1: 332.18,
    y1: 476.25,
    x2: 406.74,
    y2: 481.79,
    gradientTransform: "translate(-44.83 -28.9) rotate(-12.84)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_112",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 112",
    cx: 369.42,
    cy: 471.76,
    fx: 369.42,
    fy: 471.76,
    r: 27.14,
    gradientTransform: "translate(-44.83 -28.9) rotate(-12.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8461d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7138b6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192-5",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 192",
    cx: 359.94,
    cy: 477.92,
    fx: 359.94,
    fy: 477.92,
    r: 0.74,
    gradientTransform: "translate(-44.83 -28.9) rotate(-12.84)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192-6",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 192",
    cx: 370.43,
    cy: 478.11,
    fx: 370.43,
    fy: 478.11,
    r: 0.74,
    gradientTransform: "translate(-44.83 -28.9) rotate(-12.84)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192-7",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 192",
    cx: 374.15,
    cy: 478.25,
    fx: 374.15,
    fy: 478.25,
    r: 0.74,
    gradientTransform: "translate(-44.83 -28.9) rotate(-12.84)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192-8",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 192",
    cx: 378.61,
    cy: 478.39,
    fx: 378.61,
    fy: 478.39,
    r: 0.74,
    gradientTransform: "translate(-44.83 -28.9) rotate(-12.84)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206-9",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 206",
    cx: 370.12,
    cy: 495.08,
    fx: 370.12,
    fy: 495.08,
    r: 31.93,
    gradientTransform: "translate(-44.83 -28.9) rotate(-12.84)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50-11",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 50",
    x1: 44.85,
    y1: 103.95,
    x2: 44.85,
    y2: 51.52,
    gradientTransform: "translate(331.75 182.82) rotate(-168.31)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_108",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 108",
    cx: 45.32,
    cy: 76.42,
    fx: 45.32,
    fy: 76.42,
    r: 21.88,
    gradientTransform: "translate(242.46 163.97) rotate(-106.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#000101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#040508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#0a0c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#121625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#1e243b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2b3456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#3c4877"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4f5f9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#657ac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7c96f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#819cff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50-12",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 50",
    x1: 23.84,
    y1: 103.95,
    x2: 23.84,
    y2: 94.42,
    gradientTransform: "translate(331.75 182.82) rotate(-168.31)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_244-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 244",
    x1: -24.16,
    y1: 103.13,
    x2: 12.56,
    y2: 103.13,
    gradientTransform: "translate(312.72 165.66) rotate(-163.49)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_244"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_204-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 204",
    cx: 45.32,
    cy: 76.42,
    fx: 45.32,
    fy: 76.42,
    r: 26.21,
    gradientTransform: "translate(331.75 182.82) rotate(-168.31)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_204"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_225-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 225",
    x1: -2.21,
    y1: 116.57,
    x2: 26.49,
    y2: 116.57,
    gradientTransform: "translate(331.75 182.82) rotate(-168.31)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_225"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_129",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 129",
    x1: 43.3,
    y1: 98.19,
    x2: 43.3,
    y2: 54.52,
    gradientTransform: "translate(331.75 182.82) rotate(-168.31)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959f9a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13-5",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 13",
    cx: 67.02,
    cy: 149.46,
    fx: 67.02,
    fy: 149.46,
    r: 20.65,
    gradientTransform: "translate(-16.71 -22.41) rotate(-11.53)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_38-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 38",
    x1: 67.02,
    y1: 164.65,
    x2: 67.02,
    y2: 134.26,
    gradientTransform: "translate(-16.71 -22.41) rotate(-11.53)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_36-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 36",
    x1: 67.02,
    y1: 163.42,
    x2: 67.02,
    y2: 135.49,
    gradientTransform: "translate(-16.71 -22.41) rotate(-11.53)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192-9",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 192",
    cx: 67.02,
    cy: 148.58,
    fx: 67.02,
    fy: 148.58,
    r: 9.92,
    gradientTransform: "translate(-16.71 -22.41) rotate(-11.53)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13-6",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 13",
    cx: 239.09,
    cy: 69.8,
    fx: 239.09,
    fy: 69.8,
    r: 23.73,
    gradientTransform: "translate(16.03 2.9) rotate(12.84)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_38-3",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 38",
    x1: 239.09,
    y1: 87.27,
    x2: 239.09,
    y2: 52.34,
    gradientTransform: "translate(16.03 2.9) rotate(12.84)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_36-3",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 36",
    x1: 239.09,
    y1: 85.86,
    x2: 239.09,
    y2: 53.75,
    gradientTransform: "translate(16.03 2.9) rotate(12.84)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192-10",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 192",
    cx: 230.08,
    cy: 69.44,
    fx: 230.08,
    fy: 69.44,
    r: 7.56,
    gradientTransform: "translate(16.03 2.9) rotate(12.84)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192-11",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 192",
    cx: -247.4,
    cy: 69.23,
    fx: -247.4,
    fy: 69.23,
    r: 7.56,
    gradientTransform: "translate(16.86 3.3) rotate(-167.16) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50-13",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 50",
    x1: 51.38,
    y1: 280.16,
    x2: 109.67,
    y2: 280.16,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50-14",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 50",
    x1: 51.46,
    y1: 277.84,
    x2: 109.66,
    y2: 277.84,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_59",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 59",
    x1: 81.61,
    y1: 274.47,
    x2: 81.61,
    y2: 260.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d47d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#713592"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_204-3",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 204",
    cx: 81.4,
    cy: 267.47,
    fx: 81.4,
    fy: 267.47,
    r: 16.25,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_204"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192-12",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 192",
    cx: -121.6,
    cy: 18.3,
    fx: -121.6,
    fy: 18.3,
    r: 6.55,
    gradientTransform: "translate(93.39 387.68) rotate(90)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192-13",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 192",
    cx: -119.21,
    cy: 8.49,
    fx: -119.21,
    fy: 8.49,
    r: 7.38,
    gradientTransform: "translate(93.39 387.68) rotate(90)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_65",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 65",
    x1: 77.16,
    y1: 290.52,
    x2: 77.16,
    y2: 274.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50-15",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 50",
    x1: 52.87,
    y1: 372.68,
    x2: 120.29,
    y2: 372.68,
    gradientTransform: "translate(5.39 -4.28) rotate(102.39) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50-16",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 50",
    x1: 52.96,
    y1: 370.02,
    x2: 120.28,
    y2: 370.02,
    gradientTransform: "translate(5.39 -4.28) rotate(102.39) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_59-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 59",
    x1: 89.36,
    y1: 363.6,
    x2: 89.36,
    y2: 348.09,
    gradientTransform: "translate(5.39 -4.28) rotate(102.39) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_59"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_204-4",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 204",
    cx: 89.12,
    cy: 355.57,
    fx: 89.12,
    fy: 355.57,
    r: 18.63,
    gradientTransform: "translate(5.39 -4.28) rotate(102.39) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_204"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192-14",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 192",
    cx: -425.85,
    cy: 13.45,
    fx: -425.85,
    fy: 13.45,
    r: 7.5,
    gradientTransform: "translate(-84.47 69.17) rotate(-167.03)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192-15",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 192",
    cx: -428.72,
    cy: 2.23,
    fx: -428.72,
    fy: 2.23,
    r: 8.46,
    gradientTransform: "translate(-84.47 69.17) rotate(-167.03)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_65-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 65",
    x1: 83.14,
    y1: 387.11,
    x2: 83.14,
    y2: 363.24,
    gradientTransform: "translate(5.39 -4.28) rotate(102.39) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_65"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_113",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 113",
    x1: -114.85,
    y1: 288.47,
    x2: -78.91,
    y2: 288.47,
    gradientTransform: "translate(-129.04 4.43) rotate(-92.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#95699e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#784aa6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_105",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 105",
    cx: -93.05,
    cy: 287.67,
    fx: -93.05,
    fy: 287.67,
    r: 17.25,
    gradientTransform: "translate(-129.04 4.43) rotate(-92.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcc5d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3a9e4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_110",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 110",
    cx: -92.01,
    cy: 285.24,
    fx: -92.01,
    fy: 285.24,
    r: 21.83,
    gradientTransform: "translate(-129.04 4.43) rotate(-92.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#caa7c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a8ed5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_65-3",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 65",
    x1: 153.63,
    y1: 184.04,
    x2: 153.63,
    y2: 164.6,
    gradientTransform: "translate(-27.47 -15.55) rotate(-20.12)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_65"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192-16",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 192",
    cx: 160.11,
    cy: 77.37,
    fx: 160.11,
    fy: 77.37,
    r: 10.85,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_192"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_10-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 10",
    x1: 340.57,
    y1: 213.73,
    x2: 333.65,
    y2: 154.34,
    gradientTransform: "translate(58.67 -17.15) rotate(15.07)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_10-3",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 10",
    x1: 333.86,
    y1: 213.96,
    x2: 333.86,
    y2: 153.1,
    gradientTransform: "translate(58.67 -17.15) rotate(15.07)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_135-4",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 135",
    x1: 289.35,
    y1: 246.69,
    x2: 284.88,
    y2: 208.27,
    gradientTransform: "translate(173.22 -188.19) rotate(19.3) scale(1 1.57)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_135"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_3",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 3",
    x1: 232.66,
    y1: 113.14,
    x2: 232.66,
    y2: 64.08,
    gradientTransform: "translate(722.4) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6e27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_3-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 3",
    x1: 250.01,
    x2: 250.01,
    y2: 80.06,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_3-3",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 3",
    x1: 267.17,
    x2: 267.17,
    y2: 94.84,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_152",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 152",
    x1: 481.95,
    y1: 113.04,
    x2: 481.95,
    y2: 64.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a4152c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c73e27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_152-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 152",
    x1: 466.29,
    y1: 112.92,
    x2: 466.29,
    y2: 80.06,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_152"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_152-3",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 152",
    x1: 449.72,
    y1: 112.92,
    x2: 449.72,
    y2: 94.84,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_152"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_57-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 57",
    cx: 292.05,
    cy: -81.77,
    fx: 292.05,
    fy: -81.77,
    r: 34.59,
    gradientTransform: "translate(121.41 49.81) rotate(39.39)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_57"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13-7",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 13",
    cx: 289.37,
    cy: -81.98,
    fx: 289.37,
    fy: -81.98,
    r: 34.51,
    gradientTransform: "translate(121.41 49.81) rotate(39.39)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_329",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 329",
    x1: 269,
    y1: -61.44,
    x2: 269,
    y2: -72.73,
    gradientTransform: "translate(200.31 6.85) rotate(48.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#683b55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#4e2c40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#24141d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#090508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_57-3",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 57",
    cx: 407.38,
    cy: 161.47,
    fx: 407.38,
    fy: 161.47,
    r: 5.47,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_57"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_57-4",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 57",
    cx: 383.12,
    cy: 179.64,
    fx: 383.12,
    fy: 179.64,
    r: 18.66,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_57"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "devops"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M498.86,219.2l-43.45-30.22c-2.99-2.08-3.81-6.15-1.85-9.23l24.69-38.72c2.07-3.25,6.44-4.13,9.61-1.92l46.12,32.07c3.15,2.19,3.86,6.55,1.58,9.62l-27.35,36.86c-2.19,2.95-6.32,3.62-9.33,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M497.89,211.36l-34.86-24.24c-2.4-1.67-3.06-4.94-1.48-7.4l19.8-31.06c1.66-2.61,5.16-3.31,7.71-1.54l36.99,25.73c2.52,1.76,3.1,5.25,1.26,7.72l-21.94,29.57c-1.75,2.36-5.07,2.91-7.49,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M497.57,208.79l-32.04-22.28c-2.21-1.53-2.81-4.54-1.36-6.81l18.2-28.55c1.53-2.4,4.75-3.04,7.08-1.42l34.01,23.65c2.32,1.61,2.85,4.83,1.16,7.1l-20.17,27.18c-1.61,2.17-4.66,2.67-6.88,1.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "487.85 139.12 489.06 147.12 526.05 172.84 533.97 171.19 487.85 139.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "498.86 219.2 497.89 211.36 463.03 187.12 455.41 188.99 498.86 219.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M505.48,189.99l3.79-5.2-3.3-1.79c.49-1.22.77-2.49.86-3.76l3.67-.24-1-6.36-3.6,1.06c-.5-1.18-1.18-2.28-2.05-3.27l2.43-2.76-5.2-3.79-1.79,3.3c-1.22-.49-2.49-.77-3.76-.86l-.24-3.67-6.36,1,1.06,3.6c-1.18.5-2.28,1.18-3.27,2.05l-2.76-2.43-3.79,5.2,3.3,1.79c-.49,1.22-.77,2.49-.86,3.76l-3.67.24,1,6.36,3.6-1.06c.5,1.18,1.18,2.28,2.05,3.27l-2.43,2.76,5.2,3.79,1.79-3.3c1.22.49,2.49.77,3.76.86l.24,3.67,6.36-1-1.06-3.6c1.18-.5,2.28-1.18,3.27-2.05l2.76,2.43ZM491.07,183.69c-2.9-2.02-3.62-6.01-1.6-8.91,2.02-2.9,6-3.62,8.91-1.6s3.62,6,1.6,8.91-6,3.62-8.91,1.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M293.22,52.69l-30.63-5.04c-2.11-.35-3.57-2.3-3.31-4.42l3.31-26.73c.28-2.25,2.37-3.81,4.6-3.44l32.51,5.35c2.22.37,3.7,2.49,3.26,4.7l-5.19,26.42c-.41,2.11-2.43,3.51-4.56,3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M290.73,48.78l-24.57-4.05c-1.69-.28-2.86-1.84-2.65-3.55l2.66-21.44c.22-1.8,1.9-3.06,3.69-2.76l26.07,4.29c1.78.29,2.96,2,2.62,3.77l-4.16,21.19c-.33,1.69-1.95,2.82-3.66,2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M289.91,47.5l-22.59-3.72c-1.56-.26-2.63-1.7-2.44-3.26l2.44-19.71c.21-1.66,1.75-2.81,3.39-2.54l23.97,3.95c1.64.27,2.72,1.84,2.41,3.46l-3.83,19.48c-.31,1.56-1.79,2.59-3.36,2.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "267.2 13.06 269.85 16.99 295.93 21.29 299.71 18.41 267.2 13.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "293.22 52.69 290.73 48.78 266.16 44.74 262.59 47.64 293.22 52.69"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "275.78 24.34 271.09 23.19 268.32 40 273.18 40.15 273.41 38.71 270.07 37.96 271.89 25.11 275.55 25.71 275.78 24.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "287.96 26.34 292.77 26.77 290 43.57 285.35 42.16 285.59 40.71 289 41.08 291.39 28.32 287.73 27.72 287.96 26.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "274.18 40.18 284.35 26.16 286.91 26.58 275.93 40.47 274.18 40.18"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M75.6,323.2c0,12.34-19.33,20.33-31.67,20.33s-22.34-10-22.34-22.34,10-27.86,22.34-27.86,31.67,17.54,31.67,29.88Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-119",
    cx: 258.13,
    cy: 214.43,
    r: 142.23
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M360.45,247.23c-7.81,0-17.59-1.29-27.44-3.8-12.81-3.27-36.48-11.42-51.05-29.29l.83-.68c24.84,30.48,80.33,36.63,91,30.42,4.03-2.35,7.27-5.26,9.74-8.4-.09-.04-.18-.08-.28-.13-8.77-4.06-12.59-10.64-10.22-17.61,1.87-5.5,7.32-9.67,11.46-8.73,3.17.71,5.37,3.53,6.01,7.72.82,5.33-.89,12.18-5.31,18.32,19.57,8.47,45.39,8.76,45.65,8.76v1.07c-.28,0-26.51-.29-46.31-8.95-2.57,3.33-5.96,6.41-10.2,8.87-2.79,1.63-7.73,2.42-13.88,2.43ZM383.23,209.94c-3.48,0-7.63,3.58-9.18,8.14-1.04,3.07-2.19,10.82,9.66,16.3.16.08.33.15.49.22,4.35-5.94,6.04-12.57,5.25-17.71-.57-3.73-2.47-6.23-5.19-6.84-.33-.07-.67-.11-1.02-.11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M415.83,280.71c-6.4-3.25-10.69-4.94-15.69-9.6,0,0,45.4,7.22,75.83,2.77l68.95,7.59s-50.91,19.73-129.1-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M415.83,280.71s74.98,18.85,129.1.76c0,0,2.2,1.91,1.53,5.53,0,0-62.21,14.58-130.98-3.15,0,0-.26-1.61.34-3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M400.14,271.11s-.86,1.96-.5,4.54l15.84,8.2.34-3.14s-11.07-5.61-15.69-9.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M434.83,274.75c11.63,5.43,24.21,9.37,37.7,12.04,0,0,15.51,1.09,22.99-.78l-33.71-10.86s-21.94-.19-26.98-.39Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M495.86,259.78s-.76,4.9-4.43,8.52c0,0-6.24,5.24-26.12.24-19.23-4.83-38.86-19.25-38.86-19.25l-2.51-6.73s16.43-4.84,30.54,1.11c14.1,5.96,33.65,16.97,41.39,16.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M488.32,263.81c-16.23.79-28.53-16.52-43.19-20.05-11.46-2.75-20.44-1.33-21.14-1.21-.03,0-.05,0-.05,0,6.98-4.39,29.72-11.61,49.44-5.11,11.95,3.93,21.24,13.1,22.37,19.53.04.21.07.42.09.62,0,.08,0,.16,0,.26.2,3.3-2.03,5.69-7.52,5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M440.14,242.87l-.11-.18c6.48-3.91,14.65-6.96,20.82-7.77l.03.21c-6.14.81-14.28,3.85-20.74,7.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M440.09,237.45s9.87-1.08,17.49,2.38l5.22-1.76s-8.89-3.21-19.89-1.27l-2.82.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M457.58,239.82l2.32-.78s-6.11-6.82-16.26-2.03l12.3,2.15,1.64.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M455.94,239.16s-4.5-5.17-13.1-1.87l13.1,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M485.55,266c-9.15,0-18.12-6.26-26.27-11.95-4.24-2.96-8.25-5.76-12-7.5-10.39-4.84-22.78-2.79-22.9-2.77l-.04-.21c.12-.02,12.58-2.08,23.03,2.79,3.77,1.76,7.79,4.56,12.04,7.52,10.81,7.54,23.06,16.09,35.19,9.62l.1.19c-3.05,1.63-6.11,2.32-9.14,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M465.31,268.54l4.52-11.01s5.5,4,11.35,5.51l-4.84,7.46s-5.58-.35-11.04-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M488.32,263.81c-16.23.79-28.53-16.52-43.19-20.05-11.46-2.75-20.44-1.33-21.14-1.21.79-.17,12.06-2.68,24.49,1.05,14.32,4.3,23,18.18,36.62,19.33,10.59.9,10.74-3.23,10.74-5.07.2,3.3-2.03,5.69-7.52,5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M442.17,243.13v-.95s6.17.7,12.19,3.82l-.95,1.13s-5.65-3.49-11.24-3.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M423.98,242.55s11.11-1.63,22.46,2.1c11.98,3.94,22.31,15.31,33.91,18.15,0,0-6.85-1.85-15.27-8.1s-17.49-14.88-41.11-12.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M462.59,238.96c.62.15,1.06.55.98.88-.08.33-.65.48-1.28.33-.62-.15-1.06-.55-.98-.88.08-.33.65-.48,1.28-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M466.04,240.18c-.17,1-1.92,1.53-3.91,1.2-1.99-.34-3.47-1.42-3.3-2.41.17-1,1.92-1.53,3.91-1.2,1.99.34,3.47,1.42,3.3,2.41Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M304.21,369.69c-.64,0-1.29-.01-1.94-.04-15.22-.59-27.5-5.89-36.51-15.74-8.81-9.64-14.26-23.47-16.12-40.63-15.51,2.61-26.46,6.68-26.68,6.76l-.63-1.67c.22-.08,11.36-4.22,27.13-6.86-.58-6.24-.69-12.9-.34-19.94.46-9.06-3.86-16.01-12.85-20.64-28.04-14.45-98-2.46-129.07,22.13l-1.11-1.4c14.47-11.45,38.99-21.14,65.59-25.9,27.57-4.94,51.41-3.63,65.41,3.58,9.67,4.98,14.31,12.49,13.82,22.31-.35,6.92-.24,13.45.32,19.57,15.38-2.41,34.78-3.25,52.73,2.29,23.71,7.33,32.16,23.24,30.02,35.76-2.14,12.53-13.73,20.4-29.76,20.4ZM251.39,313c1.81,16.82,7.1,30.34,15.67,39.71,8.68,9.49,20.54,14.59,35.26,15.16,16.07.62,27.81-6.79,29.87-18.88,2.01-11.76-6.11-26.75-28.79-33.76-17.69-5.47-36.85-4.61-52.02-2.23Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M294.7,141.63l-3.36,80.66-1.18,28.38c-.14,3.05-2.65,5.45-5.7,5.45H87.56c-3.08,0-5.6-2.44-5.71-5.51l-3.47-109.05c-.12-3.22,2.48-5.91,5.7-5.91h204.92c3.26,0,5.85,2.72,5.7,5.98Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-190",
    points: "86.24 141.94 87.99 242.69 284.56 242.5 288.17 141.53 86.24 141.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M81.85,250.61v-2.5l208.48-1.21-.17,3.77s.06,5.05-5.71,5.45H87.56s-5.53-.31-5.71-5.51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-158",
    cx: 271.94,
    cy: 251.51,
    r: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "167.58 256.12 171.98 276.89 198.02 276.89 202.3 256.12 167.58 256.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "169.11 263.35 200.16 266.51 202.3 256.12 167.58 256.12 169.11 263.35"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 152.45,
    y: 276.89,
    width: 63.57,
    height: 3.97
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "216.02 276.89 198.46 274.77 171.53 274.77 152.45 276.89 216.02 276.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "201.03 280.86 201.03 276.89 214.9 276.89 214.05 280.86 201.03 280.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M294.7,141.63l-3.36,80.66-1.01,8.19-3.57-4.61,3-85.54h-104.7l-4.67-4.68h108.6c3.26,0,5.86,2.72,5.71,5.98Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "191.35 141.72 285.64 209.76 288.17 141.53 191.35 141.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M80.51,208.64l5.73,4.01,1,30.72h49.48l11.49,12.75h-60.65s-4.49.2-5.71-4.61l-1.34-42.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "87.52 215.66 127.51 242.65 87.99 242.69 87.52 215.66"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M220.08,225.28c-18.01,0-30.21-13.03-40.97-24.52-8.66-9.25-16.83-17.98-26.11-17.98-8.13,0-14.75,6.62-14.75,14.75s6.62,14.75,14.75,14.75v13.01c-15.3,0-27.76-7.75-27.76-23.05,0-18.68,12.45-32.46,27.76-32.46s25.43,11.24,35.6,22.1c9.82,10.49,19.1,20.4,31.47,20.4v13.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M220.08,229.98c-18.01,0-30.21-13.03-40.97-24.52-8.66-9.25-16.83-17.98-26.11-17.98-8.13,0-14.75,6.62-14.75,14.75s6.62,14.75,14.75,14.75v13.01c-15.3,0-27.76-12.45-27.76-27.75s12.45-27.76,27.76-27.76,25.43,11.24,35.6,22.1c9.82,10.49,19.1,20.4,31.47,20.4l5.86,6.93-5.86,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M225.94,223.91l-5.86-6.93v-4.7c8.13,0,14.75-6.62,14.75-14.75s-6.62-14.75-14.75-14.75c-9.85,0-19.87,9.98-29.56,19.64-11.28,11.24-22.94,22.87-37.52,22.87v-13.01c9.2,0,18.49-9.26,28.34-19.07,11.56-11.52,23.51-23.43,38.74-23.43s27.75,13.78,27.75,32.46c0,10.57-6.59,21.68-21.89,21.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M220.08,229.98l5.86-6.08-5.86-6.93c8.13,0,14.75-6.62,14.75-14.75s-6.62-14.75-14.75-14.75c-9.85,0-19.87,9.98-29.56,19.64-11.28,11.24-22.94,22.87-37.52,22.87l-5.56-6.19,5.56-6.82c9.2,0,18.49-9.26,28.34-19.07,11.56-11.52,23.51-23.43,38.74-23.43s27.75,12.45,27.75,27.76-12.45,27.75-27.75,27.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "190.66 217.06 198.8 206.91 199.72 203.03 197.13 200.65 185.46 212.11 190.66 217.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M213.57,175.21l2.29-5.13s6.71-1.38,14.39,1.86l.82,4.81s-6.45-3.8-17.5-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M145.35,175.55l4.29-5.55s8.21-1.33,17.31,3.27v4.7s-10.48-4.92-21.6-2.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 154.92,
    width: 25.42,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 159.2,
    width: 38.35,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 150.81,
    width: 25.42,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 146.14,
    width: 15.25,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 122.78,
    y: 154.78,
    width: 3.25,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 167.92,
    width: 25.42,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 172.2,
    width: 21.7,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 118.15,
    y: 172.2,
    width: 21.7,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 163.81,
    width: 25.42,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 122.78,
    y: 167.78,
    width: 3.25,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 112.92,
    y: 146.14,
    width: 15.25,
    height: 2.33
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 185.61,
    width: 25.42,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 189.89,
    width: 38.35,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 181.5,
    width: 25.42,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 176.83,
    width: 15.25,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 122.78,
    y: 185.47,
    width: 3.25,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 198.61,
    width: 25.42,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 202.89,
    width: 21.7,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 118.15,
    y: 202.89,
    width: 21.7,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 194.5,
    width: 25.42,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 122.78,
    y: 198.47,
    width: 3.25,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 229.23,
    width: 25.42,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 233.51,
    width: 21.7,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 118.15,
    y: 233.51,
    width: 21.7,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 225.12,
    width: 25.42,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 122.78,
    y: 229.09,
    width: 3.25,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 208,
    width: 17.7,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 216.72,
    width: 12.71,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 221,
    width: 21.7,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 118.15,
    y: 221,
    width: 21.7,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 95.74,
    y: 212.61,
    width: 25.42,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 110.98,
    y: 216.58,
    width: 15.05,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 122.78,
    y: 208,
    width: 3.25,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 112.92,
    y: 176.83,
    width: 15.25,
    height: 2.33
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "150.53 151.19 151.08 156.64 223.32 156.54 224.58 151.19 150.53 151.19"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M282.19,155.96l6.06-5.54s13.43-.09,20.45-1.07v9.23s-10.26,2.26-19.94,1.82l-6.58-4.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "282.19 173.68 287.41 169.55 306.53 170.74 304.72 179.95 287.05 178.21 282.19 173.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M287.73,199.31l-2.09,16.3s13.01.91,24.08,4.66l3.36-18.22s-8.97-3.18-25.35-2.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "292.3 199.21 291.59 216.18 285.64 215.6 287.73 199.31 292.3 199.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "293.15 178.81 293.52 169.93 287.41 169.55 282.19 173.68 287.05 178.21 293.15 178.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "294.33 150.33 293.91 160.51 288.76 160.4 282.19 155.96 288.25 150.42 294.33 150.33"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M79.66,179.08c10.28,2,19.34,9.07,23.42,19.55,6.33,16.26-1.72,34.57-17.97,40.89-1.21.47-2.44.87-3.67,1.18l-1.77-61.61Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-108",
    cx: 64.2,
    cy: 190.17,
    r: 36.24,
    transform: "translate(-135.13 166.65) rotate(-64.62)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-58",
    cx: 63.9,
    cy: 189.33,
    rx: 36.2,
    ry: 35.35,
    transform: "translate(-59.85 32.44) rotate(-19.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M56.87,159.77l-.81-4.92s14.9-4.15,27.28,4.33l-3.56,4-22.91-3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M45.58,213.94l-1.91,5.05s3.97,3.34,9.99,4.47l1.43-5.12-9.51-4.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-108",
    cx: 63.86,
    cy: 189.21,
    rx: 30.81,
    ry: 30.07,
    transform: "translate(-59.82 32.43) rotate(-19.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M93.11,179.51c5.45,15.29-3.13,32.32-19.15,38.03-16.03,5.71-33.45-2.05-38.9-17.34-.34-.95-.62-1.9-.85-2.85,0,0-.02-.07-.05-.2-.04-.19-.08-.37-.12-.56t0-.01c-3.03-14.27,5.42-29.15,20.19-34.41,11.9-4.24,24.57-1.05,32.53,7.14,1.42,1.46,2.68,3.07,3.77,4.83t.01.01h0c1.03,1.67,1.89,3.46,2.57,5.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M66.05,189.15c.37,1.03-.21,2.18-1.29,2.57-1.08.39-2.26-.14-2.63-1.17-.37-1.03.21-2.18,1.29-2.57,1.08-.39,2.26.14,2.63,1.17Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M53.23,165.61l2.5,7.03-1.25.44-2.08-5.83-.7.25-.42-1.19,1.95-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M61.84,169.12l.42,1.19-4.9,1.74.25-.52c.45-.95.8-1.72,1.04-2.31.24-.59.42-1.15.52-1.7.11-.54.09-1.02-.06-1.43-.14-.38-.36-.64-.67-.76-.31-.12-.63-.12-.98,0-.38.13-.63.35-.76.63-.13.29-.15.56-.05.82.16.44.42.76.81.95l-.51.96c-.31-.05-.6-.23-.89-.54-.29-.31-.49-.61-.59-.91-.14-.39-.17-.8-.08-1.22.08-.42.28-.81.6-1.16.32-.35.74-.62,1.28-.81.45-.16.88-.2,1.31-.11.43.08.8.27,1.11.54.32.28.55.62.69,1.03.14.4.19.84.15,1.3-.04.46-.13.91-.27,1.34-.14.43-.34,1.01-.62,1.72l2.2-.79Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M71.4,210.6c.39.08.75.26,1.07.53.32.27.56.62.71,1.05.17.47.2.94.1,1.38-.11.44-.32.84-.63,1.17-.32.33-.69.58-1.12.73-.49.17-.97.21-1.45.12-.48-.09-.91-.32-1.29-.68-.38-.36-.68-.84-.89-1.43-.29-.82-.28-1.71.05-2.65.33-.94.85-1.87,1.56-2.78l1.15.61c-.5.48-.88.99-1.15,1.52-.26.54-.42,1.05-.46,1.53.24-.48.65-.82,1.24-1.03.35-.13.73-.15,1.12-.07ZM71.86,213.69c.16-.32.17-.67.03-1.05-.13-.37-.36-.62-.68-.75-.32-.13-.66-.14-1.03,0-.36.13-.62.34-.79.64-.17.3-.21.59-.1.88l.08.21c.08.21.2.39.38.54.18.14.39.24.62.28.24.04.47.02.7-.06.37-.13.63-.36.79-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M40.41,193.91c.47.08.89.27,1.26.57.37.3.64.69.81,1.17.25.7.31,1.39.19,2.07-.13.68-.36,1.31-.7,1.9-.34.58-.78,1.23-1.32,1.93l-1.15-.61c.47-.46.86-.93,1.18-1.4.32-.47.54-.92.68-1.33-.24.33-.61.59-1.1.76-.36.13-.73.15-1.12.07-.39-.08-.74-.26-1.07-.53-.32-.27-.56-.62-.71-1.04-.18-.51-.22-1-.13-1.47.1-.47.3-.87.61-1.21.31-.34.68-.59,1.12-.75.48-.17.96-.22,1.43-.14ZM39.31,197.74c.33.15.67.16,1.04.03.36-.13.63-.35.79-.66.17-.31.19-.63.07-.95l-.08-.21c-.13-.35-.36-.6-.69-.75-.33-.16-.68-.17-1.03-.05-.36.13-.62.36-.78.69-.16.33-.17.69-.02,1.1.14.39.37.66.7.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M87.42,180.37c.44.23.77.67,1.01,1.34.17.49.21.96.12,1.4-.1.45-.3.84-.61,1.17-.31.33-.69.58-1.14.74-.35.12-.73.18-1.14.16-.41-.01-.76-.1-1.06-.26l.26-1.25c.19.11.43.19.7.23.27.04.53.01.77-.07.35-.12.6-.35.76-.67s.17-.69.03-1.08c-.13-.36-.34-.61-.63-.75-.29-.14-.62-.14-.99-.01-.18.07-.33.13-.45.2-.11.06-.24.14-.37.24l-.04-.02.57-2.82-1.96.7-.42-1.19,3.75-1.34-.58,3.11c.52-.12.99-.07,1.43.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M62.57,190.83s1.18,1.66,3.73,1.66l8.24-22.66s-.32-.5-1.46-.65l-10.51,21.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M61.98,189.37s1.18,1.66,3.73,1.66l8.24-22.66s-.32-.5-1.46-.65l-10.51,21.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 46.33,
    y: 201.67,
    width: 22.19,
    height: 0.84,
    transform: "translate(-146.25 150.59) rotate(-59.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M62.6,189.85s1.13,2.09,2.29,3.55l15.32-5.79s.14-.41-.3-1.13l-17.31,3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M62.6,189.05s-.11,2.56,1.06,4.01l16.55-6.26s.14-.41-.3-1.13l-17.31,3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M67.31,189.06c.61,1.72-.28,3.61-2,4.22-1.72.61-3.61-.28-4.22-2-.61-1.72.28-3.61,2-4.22s3.61.28,4.22,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M65.71,189.63c.3.83-.14,1.75-.97,2.04s-1.75-.14-2.04-.97c-.3-.83.14-1.75.97-2.04s1.75.14,2.04.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M86.76,169.3c2.26,2.54,3.56,4.5,3.75,4.81-.66-.78-11.44-13.24-32.8-5.63-22.06,7.86-23.49,28.87-23.49,28.87,0,0-.02-.07-.05-.2-.03-.12-.07-.32-.12-.56t0-.01c-3.03-14.27,5.42-29.15,20.19-34.41,11.9-4.24,24.57-1.05,32.53,7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M90.54,174.14h0s0,0-.01,0h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "41.07 306.25 83.54 293.33 275.07 278.49 330.93 285.41 41.07 306.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M275.07,289.84c0,4.97-1.53,9.01-3.41,9.01s-3.41-4.03-3.41-9.01,1.53-9.01,3.41-9.01,3.41,4.03,3.41,9.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "223.81 282.46 144.88 295.89 70.77 297.21 83.54 293.33 223.81 282.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-204",
    points: "44.04 314.93 46.04 319.21 330.93 303.71 330.93 298.29 44.04 314.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "106.96 301.51 321.41 283.74 330.93 285.41 106.96 301.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "275.07 278.49 275.07 289.43 83.65 303.44 83.54 293.33 275.07 278.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "44.04 314.93 41.07 306.25 330.93 285.41 330.93 298.29 44.04 314.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "287.73 300.8 285.64 288.45 323.37 285.4 322.11 298.4 287.73 300.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "53.59 314.38 51.06 305.53 76.43 303.71 77.18 313.01 53.59 314.38"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-88",
    cx: 271.94,
    cy: 251.51,
    r: 9.01,
    transform: "translate(-98.19 265.96) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-112",
    cx: 283.31,
    cy: 341.31,
    rx: 9.01,
    ry: 25.51,
    transform: "translate(-76.39 600.88) rotate(-86.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M131.27,328.87c-.21,3.11-9.93,4.98-21.71,4.19-11.78-.8-21.16-3.97-20.95-7.08.21-3.11,9.93-4.98,21.71-4.19,11.78.8,21.16,3.97,20.95,7.08Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-150",
    cx: 410.7,
    cy: 336.79,
    r: 0.55
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "80.5 330.51 78.67 325.64 315.93 345.73 314.81 349.4 80.5 330.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "78.67 325.64 123.98 307.21 286.87 319.3 315.93 345.73 78.67 325.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "88.53 324.22 308.51 342.71 309.72 337.57 283.97 317.94 127.14 306.3 88.95 318.57 88.53 324.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-201",
    points: "88.95 318.57 309.72 337.57 283.97 317.94 127.14 306.3 88.95 318.57"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "303.62 332.92 97.55 315.81 98.72 315.43 302.92 332.39 303.62 332.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "297.42 328.19 106.64 312.89 107.71 312.55 296.73 327.66 297.42 328.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-206",
    points: "293.32 325.16 112.9 310.88 113.99 310.52 292.75 324.64 293.32 325.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "289.13 321.35 119.49 308.76 120.69 308.37 288.56 320.83 289.13 321.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "286.87 319.3 125.25 306.91 126.1 306.63 285.65 318.97 286.87 319.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "119.77 313.96 119.59 313.53 124.81 311.38 124.8 311.63 124.89 311.84 119.77 313.96"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 130.12,
    y: 308.19,
    width: 4.66,
    height: 0.47,
    transform: "translate(-108.41 74.64) rotate(-22.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "105.45 319.93 104.31 319.9 112.27 316.58 112.45 317.02 105.45 319.93"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 144.47,
    y: 307.75,
    width: 1.37,
    height: 0.47,
    transform: "translate(-123.74 99.13) rotate(-26.93)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "125.76 318.16 125.7 318.15 125.71 317.9 125.61 317.7 131.87 314.5 131.94 314.5 131.93 314.75 132.03 314.95 125.76 318.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "136.31 312.76 136.25 312.75 136.26 312.51 136.16 312.31 140.88 309.9 141.1 310.33 136.31 312.76"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 286.81,
    y: 323.57,
    width: 0.47,
    height: 4.51,
    transform: "translate(-147.06 315.3) rotate(-47.23)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 280.09,
    y: 318.29,
    width: 0.47,
    height: 2.66,
    transform: "translate(-144.67 308.56) rotate(-47.26)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "298.1 336.75 293.39 332.02 293.71 331.67 299.25 336.79 298.1 336.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 274.55,
    y: 319.28,
    width: 0.47,
    height: 4.95,
    transform: "translate(-144.79 267.05) rotate(-42.07)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "282.96 331.13 278.99 326.76 279.16 326.6 279.17 326.36 279.27 326.37 279.34 326.44 283.31 330.82 282.96 331.13"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 270.72,
    y: 316.72,
    width: 0.47,
    height: 1.59,
    transform: "translate(-143.05 264.23) rotate(-42.19)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-184",
    points: "269.98 326.09 269.85 326.08 268.04 323.07 268.45 322.83 270.19 325.73 269.99 325.85 269.98 326.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "265.91 319.52 264.84 317.73 265.25 317.49 266.32 319.28 265.91 319.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "274.88 334.58 272.33 330.22 272.74 329.98 275.54 334.63 274.88 334.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "257.98 317.18 257.53 316.08 257.97 315.9 258.42 317 257.98 317.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 262.1,
    y: 325.01,
    width: 0.47,
    height: 4.48,
    transform: "translate(-104.21 123.41) rotate(-22.2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "260.32 322.56 260.16 322.55 258.7 318.96 259.14 318.78 260.55 322.23 260.33 322.32 260.32 322.56"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 252.14,
    y: 321.58,
    width: 0.47,
    height: 2.97,
    transform: "translate(-87.76 94.22) rotate(-18.07)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "250.59 318.34 250.01 316.55 250.46 316.4 251.04 318.19 250.59 318.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "255.33 332.88 253.95 328.65 254.4 328.51 256.03 332.95 255.33 332.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "243.2 321.03 242.53 317.71 242.99 317.62 243.66 320.94 243.2 321.03"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 242.12,
    y: 315.49,
    width: 0.47,
    height: 0.38,
    transform: "translate(-59.95 56.84) rotate(-11.91)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 244.17,
    y: 323.72,
    width: 0.47,
    height: 4.12,
    transform: "translate(-59.94 55.15) rotate(-11.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 234.32,
    y: 315.25,
    width: 0.47,
    height: 1.81,
    transform: "translate(-14.49 11.29) rotate(-2.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 234.93,
    y: 326.99,
    width: 0.47,
    height: 4.16,
    transform: "translate(-15.19 11.4) rotate(-2.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 234.58,
    y: 320.3,
    width: 0.47,
    height: 2.73,
    transform: "translate(-15.02 11.52) rotate(-2.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 150.78,
    y: 309.38,
    width: 4.72,
    height: 0.47,
    transform: "translate(-140.37 127.49) rotate(-31.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 132.16,
    y: 320.42,
    width: 6.49,
    height: 0.47,
    transform: "translate(-148.86 119.79) rotate(-31.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 143.11,
    y: 314.28,
    width: 4.32,
    height: 0.47,
    transform: "translate(-144.16 124.11) rotate(-31.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 157.6,
    y: 312.7,
    width: 4.33,
    height: 0.47,
    transform: "translate(-155.82 158.47) rotate(-36.87)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "164.02 310.04 163.93 310.03 163.94 309.79 163.81 309.61 163.95 309.5 164.23 309.88 164.02 310.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "150.57 320.15 150.26 319.79 154.77 316.4 155.05 316.78 150.57 320.15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 169.7,
    y: 311.17,
    width: 2.74,
    height: 0.47,
    transform: "translate(-158.25 178.05) rotate(-39.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 155.25,
    y: 322.3,
    width: 5.14,
    height: 0.47,
    transform: "translate(-181.26 204.39) rotate(-44.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 163.41,
    y: 315.88,
    width: 3.76,
    height: 0.47,
    transform: "translate(-162.53 175.45) rotate(-39.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 174.27,
    y: 313.96,
    width: 3.82,
    height: 0.47,
    transform: "translate(-172.07 222.11) rotate(-45.91)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "169.01 321.93 168.67 321.59 168.92 321.35 172.32 317.84 172.66 318.17 169.01 321.93"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 181.41,
    y: 317.29,
    width: 3.1,
    height: 0.47,
    transform: "translate(-181.06 275.26) rotate(-53.43)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "179.12 322.35 179.12 322.34 179.59 322.38 179.12 322.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "186.17 313.59 185.79 313.31 187.16 311.47 187.37 311.58 187.56 311.73 186.17 313.59"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 195.93,
    y: 312.01,
    width: 0.06,
    height: 0.47,
    transform: "translate(-172.64 318.03) rotate(-58.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 188.87,
    y: 321.08,
    width: 4.03,
    height: 0.47,
    transform: "translate(-182.72 331.14) rotate(-60.79)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "193.49 317.14 193.08 316.91 194.71 314 195.13 314.23 193.49 317.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "201.29 320.39 200.85 320.22 201.84 317.63 202.28 317.8 201.29 320.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "203.42 314.81 202.98 314.65 203.72 312.71 204.14 312.91 204.11 312.99 203.42 314.81"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 209.08,
    y: 316.61,
    width: 3.16,
    height: 0.47,
    transform: "translate(-149.03 440.91) rotate(-75.41)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 211.48,
    y: 313.19,
    width: 0.11,
    height: 0.47,
    transform: "translate(-145.07 439.2) rotate(-75.41)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "208.83 324.85 208.37 324.78 209.36 320.93 209.82 321.05 208.83 324.85"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 218.39,
    y: 314.71,
    width: 1.97,
    height: 0.47,
    transform: "translate(-110.93 510.43) rotate(-85.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 217.63,
    y: 320.16,
    width: 2.68,
    height: 0.47,
    transform: "translate(-116.74 515.08) rotate(-85.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 227.51,
    y: 314.41,
    width: 0.15,
    height: 0.47,
    transform: "translate(-90.04 538.05) rotate(-89.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 225.56,
    y: 324.07,
    width: 3.76,
    height: 0.47,
    transform: "translate(-100.54 546.42) rotate(-89.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 225.94,
    y: 317.9,
    width: 3.19,
    height: 0.47,
    transform: "translate(-93.95 540.91) rotate(-89.15)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "91.09 324.44 91.1 325.85 304.81 343.92 305.92 342.52 91.09 324.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "287.04 340.91 288.86 335.78 305.32 337.19 302.14 342.07 287.04 340.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "281.47 342.81 280.33 346.62 301.44 348.32 303.01 344.64 281.47 342.81"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "388.67 361.3 382.5 363.4 344.69 291.14 348.37 291.13 388.67 361.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-209",
    points: "344.69 291.14 350.63 289.85 348.37 291.13 344.69 291.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "350.63 289.85 389.46 354.21 388.67 361.3 348.37 291.13 350.63 289.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "447.73 348.79 453.89 350.91 491.97 277.77 488.3 277.75 447.73 348.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "491.97 277.77 486.04 276.46 488.3 277.75 491.97 277.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "486.04 276.46 448.41 339.31 447.73 348.79 488.3 277.75 486.04 276.46"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "373.68 368.27 379.72 380.78 426.43 380.04 472.82 359.9 472.63 347.42 373.68 368.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "395.33 347.73 373.68 368.27 422.81 364.19 472.63 347.42 443.46 336.75 395.33 347.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "385.31 364.19 421.12 353.49 458.61 348.9 385.31 364.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "458.61 348.9 435.44 338.58 417.76 340.81 399.93 346.68 385.31 364.19 421.12 353.49 458.61 348.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "421.12 353.49 417.76 340.81 435.44 338.58 458.61 348.9 421.12 353.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M413.07,356.9c.09.4-.16.79-.55.88-.4.09-.79-.16-.88-.55-.09-.4.16-.79.55-.88.4-.09.79.16.88.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M423.34,354.75c.09.4-.16.79-.55.88-.4.09-.79-.16-.88-.55-.09-.4.16-.79.55-.88.4-.09.79.16.88.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M427,354.06c.09.4-.16.79-.55.88-.4.09-.79-.16-.88-.55-.09-.4.16-.79.55-.88.4-.09.79.16.88.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M431.37,353.2c.09.4-.16.79-.55.88-.4.09-.79-.16-.88-.55-.09-.4.16-.79.55-.88.4-.09.79.16.88.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "422.81 364.19 426.43 380.04 472.82 359.9 472.63 347.42 422.81 364.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "381.4 377.42 377.88 370.42 423.83 368.65 470.17 350.95 469.33 359.29 425.67 376.75 381.4 377.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "381.4 377.42 382.72 376.28 425.05 374.42 467 358.73 469.33 359.29 425.67 376.75 381.4 377.42"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M405.9,333.57l-1.49-2.62c3.18-1.81,6.4-3.06,9.83-3.84,3.55-.81,7.25-1.06,10.99-.75l-.25,3c-3.43-.28-6.82-.05-10.07.69-3.14.71-6.09,1.87-9.01,3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M408.5,338.04l-1.56-2.58c2.52-1.53,5.36-2.66,8.44-3.35,3.17-.72,6.33-.91,9.4-.56l-.34,2.99c-2.73-.3-5.56-.13-8.4.51-2.76.63-5.3,1.63-7.55,2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M403.29,329.09l-1.51-2.61c3.51-2.03,7.32-3.52,11.32-4.43,4.1-.93,8.33-1.22,12.57-.86l-.25,3c-3.93-.33-7.85-.06-11.65.8-3.71.84-7.23,2.22-10.48,4.1Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-118",
    cx: 302.85,
    cy: 98.8,
    r: 21.88,
    transform: "translate(72.67 319.03) rotate(-61.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M298.26,123.28c14.18,2.93,28.04-6.18,30.98-20.36,2.93-14.18-6.18-28.05-20.36-30.98-14.18-2.93-28.05,6.18-30.98,20.36-2.93,14.18,6.18,28.04,20.36,30.98ZM308,76.19c11.83,2.45,19.44,14.02,16.99,25.86-2.45,11.83-14.02,19.44-25.86,16.99-11.83-2.45-19.44-14.03-16.99-25.86,2.45-11.83,14.02-19.44,25.86-16.99Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-161",
    cx: 302.85,
    cy: 98.8,
    r: 21.88,
    transform: "translate(72.67 319.03) rotate(-61.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M326.29,85.27l7.07-3.83-3.97-5.25-5.9,4.84s.3,3.21,2.81,4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M332.77,84.55s-5.67-.61-6.65-8.3l31.82-25.34,10.09,13.17-35.27,20.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M368.03,64.08s.32-8.12-10.09-13.17c0,0,3,5.7,10.09,13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M297.54,124.47c14.18,2.93,28.04-6.18,30.98-20.36s-6.18-28.05-20.36-30.98c-14.18-2.93-28.05,6.18-30.98,20.36-2.93,14.18,6.18,28.04,20.36,30.98ZM307.28,77.38c11.83,2.45,19.44,14.02,16.99,25.86-2.45,11.83-14.02,19.44-25.86,16.99-11.83-2.45-19.44-14.03-16.99-25.86,2.45-11.83,14.02-19.44,25.86-16.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M297.43,124.34c1.02.21,2.04.36,3.06.44l.29-3.07c-.9-.07-1.82-.2-2.73-.39-7.59-1.57-13.51-6.82-16.25-13.5l-2.78,1.35c3.15,7.51,9.84,13.4,18.41,15.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M320.83,117.6l-2-2.36c-3.9,3.83-9.13,6.2-14.73,6.47l-.13,3.09c6.39-.23,12.39-2.88,16.86-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M359.61,59.02l-32.68,20.23s-.3-.34-.52-1.42l31.58-25.09s.29,3.01,1.62,6.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M317.29,115.24l-12.08-38.18s-5.81-.96-12.02,2.13l-1.53,38.42s7.17,4.52,15.02,2.74c7.85-1.78,10.61-5.11,10.61-5.11Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M99.25,125.8l-33.04,6.74c-2.28.46-4.51-.95-5.07-3.21l-6.99-28.4c-.59-2.39.93-4.78,3.34-5.27l35.06-7.15c2.39-.49,4.71,1.1,5.13,3.51l4.96,28.82c.4,2.3-1.11,4.51-3.4,4.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M95.21,122.8l-26.5,5.4c-1.83.37-3.62-.76-4.06-2.57l-5.6-22.78c-.47-1.91.75-3.84,2.68-4.23l28.13-5.73c1.92-.39,3.78.88,4.11,2.81l3.98,23.12c.32,1.85-.89,3.62-2.73,3.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M93.88,121.82l-24.36,4.97c-1.68.34-3.33-.7-3.74-2.36l-5.15-20.95c-.43-1.76.69-3.53,2.46-3.89l25.86-5.27c1.76-.36,3.48.81,3.78,2.59l3.66,21.25c.29,1.7-.82,3.32-2.51,3.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "57.5 95.65 61.72 98.62 89.84 92.89 92.56 88.51 57.5 95.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "99.25 125.8 95.21 122.8 68.71 128.21 66.21 132.54 99.25 125.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M88.7,109.9l-.73-4.03-2.28.73c-.34-.76-.81-1.45-1.36-2.05l1.5-1.79-3.37-2.34-1.09,2.13c-.76-.29-1.57-.46-2.41-.49l-.21-2.33-4.03.73.73,2.28c-.76.34-1.45.81-2.05,1.36l-1.8-1.5-2.34,3.37,2.13,1.09c-.29.76-.46,1.57-.49,2.41l-2.33.21.73,4.03,2.28-.73c.34.76.81,1.45,1.36,2.05l-1.5,1.8,3.37,2.34,1.09-2.13c.76.29,1.57.46,2.41.49l.21,2.33,4.03-.73-.73-2.28c.76-.34,1.45-.81,2.05-1.36l1.8,1.5,2.34-3.37-2.13-1.09c.29-.76.46-1.57.49-2.41l2.33-.21ZM79.45,113.78c-2.21.45-4.36-.97-4.81-3.18-.45-2.21.97-4.36,3.18-4.81,2.21-.45,4.36.97,4.81,3.18.45,2.21-.97,4.36-3.18,4.81Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M245.93,155.4l-35.13-8.01c-2.42-.55-3.97-2.92-3.52-5.36l5.72-30.73c.48-2.58,3.01-4.25,5.57-3.66l37.28,8.5c2.54.58,4.1,3.15,3.45,5.67l-7.88,30.24c-.63,2.42-3.07,3.9-5.5,3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M247.83,149.68l-37.79-8.62c-2.6-.59-4.27-3.14-3.78-5.76l6.16-33.05c.52-2.78,3.24-4.57,6-3.94l40.1,9.14c2.74.62,4.42,3.39,3.71,6.1l-8.47,32.53c-.68,2.6-3.3,4.19-5.92,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M245.02,144.62l-30.31-6.91c-2.09-.48-3.43-2.52-3.04-4.62l4.94-26.51c.41-2.23,2.6-3.66,4.81-3.16l32.17,7.33c2.2.5,3.54,2.72,2.97,4.9l-6.8,26.09c-.54,2.09-2.65,3.36-4.75,2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M244.1,142.96l-27.86-6.35c-1.92-.44-3.15-2.31-2.79-4.25l4.54-24.37c.38-2.05,2.39-3.37,4.42-2.9l29.57,6.74c2.02.46,3.26,2.5,2.73,4.5l-6.25,23.98c-.5,1.92-2.43,3.09-4.36,2.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "218.41 98.31 221.42 103.41 253.59 110.75 258.52 107.45 218.41 98.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "247.83 149.68 245.02 144.62 214.71 137.71 210.04 141.06 247.83 149.68"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "230.89 113.64 219.69 120.48 227.48 131.8 228.65 129.66 223.78 121.05 231.61 114.99 230.89 113.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "240.83 115.9 247.95 126.92 236.03 133.75 235.9 131.31 244.02 125.67 239.59 116.81 240.83 115.9"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M52.42,277.65l24.45-7.68c.98-.19,1.99-.21,2.98-.05l28.73,8.48c1.33.21,1.48,2.07.2,2.49l-28.9,9.2c-2.01.67-4.2.56-6.13-.31l-21.61-9.69c-1.14-.51-.95-2.19.28-2.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "51.46 278.36 57.53 266.34 105.87 266.66 109.66 279.51 79.25 289.34 51.46 278.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M58.15,265.96l20-4.89c.8-.16,1.63-.17,2.44-.04l24.47,5.31c1.09.17,1.17,1.27.13,1.61l-24.62,6.16c-1.64.55-3.43.46-5.01-.25l-17.62-5.91c-.94-.42-.78-1.79.23-1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M60.04,265.92l18.21-4.54c.73-.14,1.48-.16,2.22-.04l22.28,5c.99.16,1.06,1.08.11,1.39l-22.41,5.61c-1.5.5-3.13.42-4.57-.23l-16.05-5.38c-.85-.38-.71-1.63.21-1.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "74.43 290.04 76.32 274.15 57.92 267.96 52.67 280.32 74.43 290.04"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.91,264.7c-.21,0-.47.01-.76.06-.29.04-.69.12-1.2.24l-1.86.42c-.65.15-1.28.24-1.89.27-.6.03-1.15.03-1.64,0,.19.3-.17.56-1.07.76l-2.15.49c-.51.11-.85.21-1.05.27-.19.07-.27.13-.25.18.02.05.15.11.37.18l.65.19-1.7.39-1.05-.33c-.51-.16-.86-.29-1.07-.38-.21-.09-.25-.2-.13-.33.12-.13.52-.27,1.21-.42l2.64-.59c.52-.12.87-.25,1.02-.39.15-.14.02-.27-.4-.38l1.54-.34c.45.1.99.14,1.62.11.63-.03,1.21-.11,1.75-.23l2.68-.6c.65-.14,1.23-.23,1.75-.24.52-.02.97,0,1.36.04.38.05.88.13,1.51.24l1.31.24-1.71.39-.77-.15c-.27-.05-.51-.08-.72-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M77.93,270.04c.21.01.48-.01.8-.06.33-.05.78-.15,1.36-.29l2.3-.55c.68-.16,1.34-.27,2-.32.66-.05,1.24-.07,1.74-.05-.09-.34.37-.63,1.4-.88l2.47-.6c.58-.14.98-.25,1.2-.33.22-.08.3-.14.26-.19-.05-.05-.2-.1-.47-.15l-.77-.15,1.89-.45,1.31.24c.64.12,1.09.21,1.35.29.26.07.34.17.24.3-.1.13-.55.29-1.33.48l-3.21.78c-.67.16-1.14.33-1.43.51-.29.18-.21.32.24.44l-1.95.48c-.47-.11-1.07-.13-1.81-.06-.73.07-1.43.19-2.1.35l-3.11.76c-.79.19-1.45.3-1.98.32-.54.02-.96,0-1.29-.07-.32-.07-.74-.18-1.23-.34l-1.05-.33,1.87-.45.65.19c.23.07.44.11.65.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M79.55,274.47l.34,15.61s-2.58,1.01-5.46-.04l1.9-15.89s1.41.87,3.22.32Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M357.46,128.43l-20,26.19c-.46,1.05-.73,2.18-.79,3.32l4.95,33.54c-.09,1.54,1.95,2.16,2.74.84l20.27-30.09c1.24-2.09,1.66-4.56,1.16-6.94l-5.53-26.58c-.29-1.41-2.22-1.61-2.8-.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "358.5 127.53 338.16 132.07 326.62 186.26 342.61 192.96 363.96 161.34 358.5 127.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M337.59,132.68l-10.39,21.18c-.37.86-.59,1.78-.65,2.72l-.07,28.7c-.07,1.26,1.13,1.63,1.77.54l12.95-26.04c1.02-1.71,1.36-3.73.95-5.67l-2.28-21.18c-.24-1.15-1.82-1.31-2.29-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M337.08,134.78l-9.56,19.27c-.34.78-.54,1.62-.59,2.47l.11,26.17c-.06,1.15.95,1.46,1.53.47l11.79-23.71c.93-1.55,1.23-3.4.87-5.17l-2.08-19.29c-.22-1.05-1.65-1.2-2.08-.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "365.92 156.11 342.28 155.03 339.87 132.91 360.39 129.36 365.92 156.11"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M330.58,157.84c.05-.24.13-.52.25-.83.12-.32.31-.74.56-1.28l.93-1.98c.33-.7.58-1.38.77-2.05.19-.67.32-1.28.41-1.84.29.29.67-.05,1.12-1.01l1.07-2.28c.25-.54.44-.91.56-1.1.12-.2.21-.28.26-.24.05.04.09.19.11.46l.06.77.85-1.8-.11-1.26c-.06-.61-.11-1.04-.16-1.29-.05-.25-.17-.33-.34-.23-.17.1-.43.51-.77,1.25l-1.31,2.81c-.26.56-.49.91-.69,1.05-.2.14-.31-.05-.33-.55l-.76,1.64c0,.53-.09,1.15-.28,1.84-.19.7-.42,1.33-.68,1.9l-1.33,2.85c-.32.69-.55,1.32-.7,1.9-.15.58-.25,1.09-.29,1.53-.04.44-.07,1.02-.1,1.75l-.05,1.53.86-1.82.02-.9c0-.31.03-.59.08-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M337.28,155.81c-.04.24-.13.53-.27.88-.14.35-.36.84-.66,1.45l-1.18,2.44c-.35.72-.63,1.43-.85,2.16-.22.73-.38,1.37-.48,1.94-.36-.19-.8.26-1.32,1.35l-1.27,2.62c-.3.62-.52,1.04-.66,1.27-.14.22-.23.31-.27.25-.04-.06-.06-.25-.05-.56l.02-.9-.97,2-.05,1.53c-.02.74-.03,1.27-.01,1.58.02.31.11.42.28.34.17-.09.46-.54.87-1.37l1.66-3.4c.34-.71.65-1.2.92-1.48.27-.28.41-.16.43.38l1.01-2.06c0-.55.12-1.23.38-2.04.26-.8.56-1.56.91-2.26l1.61-3.3c.41-.83.69-1.55.85-2.14.16-.59.24-1.08.24-1.46,0-.38-.02-.87-.08-1.47l-.11-1.25-.96,1.98.06.77c.02.27.01.52-.03.76Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M341.85,158.72l22.78,3.52s1.77-2.64,1.3-6.12l-23.64-1.08s.14,1.95-.44,3.69Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M181.64,68.93l9.68,8.61c.72.75.83,1.9.25,2.78l-8.39,20.56c-1.28,2.77-4.14,4.46-7.18,4.25l-37.54-2.67c-1.87-.15-3.23-1.84-2.99-3.7l1.92-14.37,44.25-15.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M138.1,83.41l12.41-11.98c.95-.92,2.21-1.46,3.54-1.53l26.43-1.23c1.76-.08,1.41,1,.55,2.53l-7.22,14.82c-.84,1.26-2.26,2.02-3.77,2.01l-30.54-.77c-1.93-.14-2.79-2.5-1.39-3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M139.11,82.59l11.71-11.31c.9-.87,2.09-1.38,3.34-1.44l24.94-1.16c1.66-.08,1.33.94.52,2.39l-6.81,13.98c-.79,1.19-2.13,1.9-3.56,1.89l-28.82-.73c-1.82-.13-2.63-2.36-1.31-3.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "173.81 86.02 183.18 100.87 191.57 80.31 181.03 71.2 173.81 86.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M170.03,88.02l5.96,17.1s4.05,1.13,7.18-4.25l-9.37-14.85s-1.4,2.07-3.77,2.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "145.6 81.93 151.51 82.34 174.63 72.75 170.79 72.4 145.6 81.93"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M408.48,224.09c-3.9.46-6.07-16.78-5.58-21.85.6-6.18,2.27-12.98,6.17-13.44s8.3,9.58,9.05,15.97c.75,6.39-5.74,18.86-9.64,19.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M420.15,122.44c-11.62,13.88-26.05,17.67-40.43,6.67-23.03-17.61-32.92-40.01-20.18-52.88,11.43-11.54,44.22-14.08,58.11-2.46,13.88,11.62,14.12,34.78,2.5,48.66Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M340.43,236.37l-4.06,11.62c2.24-6.42,5.47-10.59,4.06-11.62ZM336.37,247.99l-4.07,11.61c1.02-.31,1.82-5.2,4.07-11.61ZM340.43,236.37l-4.06,11.62c2.24-6.42,5.47-10.59,4.06-11.62ZM336.37,247.99l-4.07,11.61c1.02-.31,1.82-5.2,4.07-11.61ZM348.09,258.05l3.94,2.24,4.26-11.62-4.56-.76c.08-.43.16-.86.22-1.29.33-1.99.44-3.94.39-5.79l4.77-2.99-2.17-10.24-4.57,4.37c-.64-1.31-1.42-2.45-2.34-3.41-.25-.28-.52-.54-.79-.77l2.8-6.46-7.44-2.42h0l-1.79,6.51c-1.66,0-3.36.42-5.04,1.18l-.82-6.15-8.19,6.2,1.89,5.45c-1.48,1.68-2.83,3.63-4,5.82l-3.95-2.23-4.26,11.62,4.56.76c-.49,2.45-.67,4.83-.6,7.08l-4.77,2.99,2.17,10.24,4.57-4.37c.82,1.67,1.87,3.08,3.13,4.17l-2.8,6.47,7.32,2.86,1.13-4.12.77-2.82c1.66,0,3.37-.42,5.05-1.18l.81,6.15,8.19-6.2-1.89-5.45c1.16-1.33,2.25-2.81,3.22-4.46.27-.45.52-.91.78-1.37ZM336.37,247.99c-2.25,6.42,0,13.03-4.07,11.61-4.08-1.44-5.56-7.79-3.32-14.19,2.25-6.42,7.37-10.46,11.44-9.03,4.08,1.42-1.82,5.2-4.06,11.62ZM340.43,236.37l-4.06,11.62c2.24-6.42,5.47-10.59,4.06-11.62ZM336.37,247.99l-4.07,11.61c1.02-.31,1.82-5.2,4.07-11.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M352.03,260.29l4.26-11.62-4.34-2.05-.7-.33.46-6.4,4.82-2.35-1.59-9.94-10.5-3.42,1.93,4.61,3.66-7.46-7.44-2.42-3.06-1-7.33-2.86-1.37,5-6.38-3.03-8.19,6.2,2.49,6.7-7.66,21.24-3.78,13.79,7.27.8-2.37,5.47,7.33,2.86,10.5,3.42-1.68-3.37-1.06-2.02,3.88,1.27,6.63,2.16,8.19-6.2-5.07-5.97,6.4-3.94,4.72.86ZM328.98,245.41c2.25-6.42,7.37-10.46,11.44-9.03l-4.06,11.62-4.07,11.61c-4.08-1.44-5.56-7.79-3.32-14.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M341.54,256.86l4.25-11.62-4.56-.76c.48-2.44.67-4.82.61-7.07l4.77-2.99-2.18-10.24-4.57,4.37c-.81-1.67-1.86-3.09-3.13-4.17l2.8-6.46-7.33-2.86-1.9,6.94c-1.66,0-3.36.42-5.04,1.18l-.81-6.14-8.19,6.2,1.89,5.45c-1.47,1.68-2.82,3.64-4,5.83l-3.95-2.23-4.25,11.62,4.56.76c-.48,2.44-.67,4.82-.61,7.07l-4.77,2.99,2.18,10.24,4.57-4.37c.81,1.67,1.86,3.09,3.13,4.17l-2.8,6.46,7.33,2.86,1.9-6.94c1.66,0,3.36-.42,5.04-1.18l.81,6.14,8.19-6.2-1.89-5.45c1.47-1.68,2.82-3.64,4-5.83l3.95,2.23ZM321.8,256.18c-4.08-1.43-5.56-7.78-3.31-14.2,2.25-6.41,7.37-10.45,11.45-9.03,4.08,1.43,5.56,7.78,3.31,14.2-2.25,6.41-7.37,10.45-11.45,9.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "357.1 237.83 346.61 234.41 341.84 237.41 352.33 240.82 357.1 237.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "345.98 269.33 335.48 265.91 333.59 260.46 344.09 263.88 345.98 269.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "336.73 224.37 342.48 226.04 344.43 224.18 348.25 225.42 350.02 221.33 339.53 217.91 336.73 224.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M321.43,267.14l5.5,2.29-.46-3.46s-2.96,1.56-5.04,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M322.28,235.66l9.26,4.9s1.34-1.8,2.38-2.52c0,0-2.41-10.21-11.64-2.37Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "493.28 113.14 497.15 64.08 482.31 64.08 483.37 112.89 493.28 113.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "477.17 113.14 478.21 80.06 466.56 80.06 468.66 112.92 477.17 113.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "459.9 113.14 460.32 94.84 450.12 94.84 451.39 112.92 459.9 113.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "482.31 64.08 480.52 67.73 480.52 113.04 483.37 112.89 482.31 64.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "466.56 80.06 463.92 83.37 464.75 112.8 468.66 112.92 466.56 80.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "450.12 94.84 448.05 96.6 448.05 112.45 451.39 112.92 450.12 94.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "500.65 112.92 443.43 112.45 443.43 114.35 500.65 114.35 500.65 112.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M438.02,151.24l-4.51-4.97-8.44,11.83-6.66-3.79-2.28-7.32,12.36-7.59-4.6-5.08c-10.13.67-17.2,8.87-17.2,8.87-2.63,4.91-2.3,14.21-2.3,14.21l-45.87,33.13c-.4,3.97,2.23,6.79,2.23,6.79,0,0,5.56,7.35,9.52,7.8l42.14-37.76s9.02,2.3,14.37.78c0,0,8.43-7.14,11.24-16.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M436.05,149.42l-2.9-3.59-10.05,10.46-6.66-3.79-2.28-7.32,12.36-7.59-2.9-3.59c-10.13.67-18.9,7.39-18.9,7.39-2.63,4.91-2.36,17.21-2.36,17.21l-45.81,30.13c-.4,3.97,7.79,14.13,11.75,14.59l42.14-37.76s9.02,2.3,14.37.78c0,0,8.43-7.14,11.24-16.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M424.81,166.32l1.97,1.82s4.64-3.72,7.25-8.44l-1.82-2.05s-2.78,4.09-7.4,8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M431.24,158.98l-28.78-6.84-.1,6.44-6.07,4.21,12.67,4.06,1.47-1.32s8.68,2.56,14.37.78c0,0,4.25-4,6.43-7.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M422.97,166.74l3.19-1.7s-.38,1.42-1.05,1.76-2.13-.07-2.13-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "410.43 165.54 402.41 155.58 402.35 158.59 408.96 166.86 412.4 167.36 410.43 165.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M362.73,189.43l37.84-26.54,2.94,3.65-34.5,29.84s-3.74-1.07-6.29-6.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M369.01,196.39s-3.48-2.32-4.55-5.62l36.11-26.12,2.94,1.9-2.94-3.65-37.84,26.54s1.36,5.1,6.29,6.95Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevops);
export default __webpack_public_path__ + "static/media/Devops.ecd98b9216dac522a27ad3aa00306bd1.svg";
export { ForwardRef as ReactComponent };